import { render, staticRenderFns } from "./ComplaintDetails.vue?vue&type=template&id=0279e2ff&scoped=true"
import script from "./ComplaintDetails.vue?vue&type=script&lang=js"
export * from "./ComplaintDetails.vue?vue&type=script&lang=js"
import style0 from "./ComplaintDetails.vue?vue&type=style&index=0&id=0279e2ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0279e2ff",
  null
  
)

export default component.exports